import store from 'vuex-store'
// import Vue from 'vue'

let palette = store.getters.palette

export default {
  labels: ['Turma 2', 'Turma 1', 'Turma 3'],
  datasets: [{
    label: 'Quantidade de Alunos',
    backgroundColor: [palette.info, palette.warning, palette.primary, palette.danger, palette.success, palette.black],
    data: [45, 50, 26]
  }]
}
